import { render, staticRenderFns } from "./fccConfiguracaoDefinidaDasDatasEGrupos.vue?vue&type=template&id=3371977a"
import script from "./fccConfiguracaoDefinidaDasDatasEGrupos.vue?vue&type=script&lang=js"
export * from "./fccConfiguracaoDefinidaDasDatasEGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports